import { render, staticRenderFns } from "./ImportarProcessosEmpenho.vue?vue&type=template&id=00ab1b41&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./ImportarProcessosEmpenho.vue?vue&type=style&index=0&id=00ab1b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ab1b41",
  null
  
)

export default component.exports